import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min"
import { useSelector, useDispatch } from 'react-redux';
import { Fragment, useEffect, useRef, useState } from "react";
import ReactPlayer from 'react-player';

import { MEDIA_ORIGIN } from "../../utils/Environment";
import { updateDisplaySliderItem, updateSlider } from "../../redux/sliderSlice";
import { updateSelectedAppDetail, updateSubscribeAppList } from "../../redux/appSlice";
import { useModal } from '../../store/ModalContext';
import LoadingSpinner from "../UI/LoadingSpinner";

import { getAppDetail, getRelatedAppList, getSubscribedAppList, removeSubscribedAppList, updateSubscribedAppList } from "../../lib/api";

const AppDetailContent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const cardRef = useRef();
  const { openThankYouSubscribeModal } = useModal();
  const { currentUser } = useSelector((state) => state.user);
  const { sliderList, displaySliderItem } = useSelector((state) => state.slider);
  const { selectedAppDetail, subscribedAppList } = useSelector((state) => state.app);

  const [leftScroll, setLeftScroll] = useState('disabled');
  const [rightScroll, setRightScroll] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [resourceType, setResourceType] = useState([]);
  const [relatedAppList, setRelatedAppList] = useState([]);
  const [scrollTop, setScrollTop] = useState('');

  if (scrollTop === '') {
    window.scrollTo(0, 0);
  }

  const handleNav = (speed, distance, step) => {
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      window.innerWidth < 640 ? cardRef.current.scrollLeft += step : cardRef.current.scrollTop += step;
      scrollAmount += Math.abs(step);
      if (scrollAmount >= distance) {
        if (window.innerWidth < 640 ? cardRef.current.scrollLeft === cardRef.current.scrollLeftMax : cardRef.current.scrollTop === cardRef.currentscrollTopMax) {
          setRightScroll('disabled')
          setLeftScroll('')
        } else {
          setRightScroll('');
          setLeftScroll('')
        }
        if ((window.innerWidth < 640 ? cardRef.current.scrollLeft : cardRef.current.scrollTop) > 10) {
          setLeftScroll('')
          setRightScroll('disabled')
        } else {
          setLeftScroll('disabled')
          setRightScroll('')
        }
        clearInterval(slideTimer);
      }
    }, speed);
  };

  const handleRelatedAppList = (tid, nid) => {
    if (tid) {
      getRelatedAppList(tid)
        .then((response) => {
          const newResponse = response.filter((details) => details.nid !== nid);
          if(currentUser) {
            setRelatedAppList(newResponse.filter((detail) => detail.user_type.includes(currentUser.user_extra_details.user_type)));
          } else {
            setRelatedAppList(newResponse);
          }          
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false)
        })
    }
  }

  useEffect(() => {
    setIsLoading(true)
    getAppDetail(currentUser, params.selectedAppUrl)
      .then((response) => {
        if (response.length > 0 || (currentUser && response && response[0].user_type.includes(currentUser.user_extra_details.user_type))) {
          dispatch(updateSelectedAppDetail(response));
          const sliderDetail = response[0].media_assets.split(',');
          dispatch(updateSlider(sliderDetail));
          dispatch(updateDisplaySliderItem(sliderDetail[0]));
          setResourceType(response[0].url_type);
          handleRelatedAppList(response[0].related_resource_tags, response[0].nid);
          setIsLoading(false);
        } else {
          history.replace('/')
          setIsLoading(false)
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false)
      })
  }, [params.selectedAppUrl, currentUser]);

  const goToRegister = () => {
    history.replace('/register')
  }

  const goBackNavigation = () => {
    history.go(-1)
  }

  const handleItemSelected = (item) => {
    setScrollTop('hidden');
    dispatch(updateDisplaySliderItem(item))
  }

  const handleAppSubscribe = (nid, popUpConsent) => {
    setIsLoading(true)
    const formData = {
      "nid": nid,
      "uid": currentUser.current_user.uid
    }
    updateSubscribedAppList(currentUser, formData)
      .then((response) => {
        if (response.status === "success") {
          setIsLoading(false);
          openThankYouSubscribeModal(popUpConsent);
        }
      })
      .catch((error) => {
        setIsLoading(false)
        console.log(error);
      })
  }

  const handleRemoveAppSubscribe = (nid) => {
    setIsLoading(true)
    removeSubscribedAppList(currentUser, nid)
      .then((response) => {
        if (response.status === 'success') {
          getSubscribedAppList(currentUser)
            .then((response) => {
              setIsLoading(false)
              dispatch(updateSubscribeAppList(response));
            })
            .catch((error) => {
              setIsLoading(false)
              console.log(error);
            })
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      })
  }

  const goToAppDetailPage = (url) => {
    setScrollTop('');
    history.push(`/appdetail${url}`)
  }

  const handleViewApp = (url) => {
    window.open(url, '_blank');
  }

  return (
    <div className="grow">
      {isLoading && (
        <div className="parentDisable">
          <LoadingSpinner />
        </div>
      )}
      {selectedAppDetail && selectedAppDetail.map((detail, key) =>
        <Fragment key={key}>
          <section className="section appDetails">
            <div className="px-5 sm:px-5 md:px-5 lg:px-14 py-5 sm:py-5 md:py-5 lg:py-8">
              <div className="flex items-stretch justify-between flex-wrap gap-4">
                <div className="flex items-center gap-3 cursor-pointer" onClick={goBackNavigation}>
                  <div className="backIconHolder">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" className="size-6 sm:size-8">
                      <path d="M20.1201 26.5604L11.4268 17.8671C10.4001 16.8404 10.4001 15.1604 11.4268 14.1338L20.1201 5.44043" stroke="#0057B8" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <p className="text-[#333] text-lg leading-[30px] sm:text-2xl sm:leading-9 barlowBold uppercase tracking-[-0.25px]">BACK</p>
                </div>
                <div className="actionSection gap-2 sm:gap-6 items-center flex sm:hidden">
                  <div className="appStatus text-[#333] text-base font-normal leading-5 tracking-[-0.25px] h-[30px] w-[86px]  rounded-[50px] bg-[#E4ECF266] border borer-[#7DA1C4]  items-center justify-center !hidden">Internal</div>
                  {resourceType && resourceType.includes(2) === true && <>
                    <div className="monitor cursor-pointer hidden">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M17.56 17.97H6.44C2.46 17.97 1.25 16.76 1.25 12.78V6.44C1.25 2.46 2.46 1.25 6.44 1.25H17.55C21.53 1.25 22.74 2.46 22.74 6.44V12.77C22.75 16.76 21.54 17.97 17.56 17.97ZM6.44 2.75C3.3 2.75 2.75 3.3 2.75 6.44V12.77C2.75 15.91 3.3 16.46 6.44 16.46H17.55C20.69 16.46 21.24 15.91 21.24 12.77V6.44C21.24 3.3 20.69 2.75 17.55 2.75H6.44Z" fill="#717375" />
                        <path d="M12 22.7497C11.59 22.7497 11.25 22.4097 11.25 21.9997V17.2197C11.25 16.8097 11.59 16.4697 12 16.4697C12.41 16.4697 12.75 16.8097 12.75 17.2197V21.9997C12.75 22.4097 12.41 22.7497 12 22.7497Z" fill="#717375" />
                        <path d="M22 13.75H2C1.59 13.75 1.25 13.41 1.25 13C1.25 12.59 1.59 12.25 2 12.25H22C22.41 12.25 22.75 12.59 22.75 13C22.75 13.41 22.41 13.75 22 13.75Z" fill="#717375" />
                        <path d="M16.5 22.75H7.5C7.09 22.75 6.75 22.41 6.75 22C6.75 21.59 7.09 21.25 7.5 21.25H16.5C16.91 21.25 17.25 21.59 17.25 22C17.25 22.41 16.91 22.75 16.5 22.75Z" fill="#717375" />
                      </svg>
                    </div>
                    {detail.enable_visit === 'True' && <><div class="text-primaryText text-base leading-5 sm:text-xl sm:leading-6 font-medium tracking-[-0.05px] cursor-pointer" onClick={() => handleViewApp(detail.web_app_url)}>Visit</div>
                    <div className="divider w-[1px] h-full bg-[#000] opacity-30"></div></>}
                  </>}
                  <div className="add flex gap-6 cursor-pointer">
                    {currentUser ? <>
                      <div className="addText text-primaryText text-base leading-5 sm:text-xl sm:leading-6 font-medium tracking-[-0.05px] flex items-center" onClick={() => subscribedAppList.some(subscribedApp => subscribedApp.nid === detail.nid) ? handleRemoveAppSubscribe(detail.nid) : handleAppSubscribe(detail.nid, detail.popup_consent)}>{subscribedAppList.some(subscribedApp => subscribedApp.nid === detail.nid) ? 'Remove' : 'Add'}</div>
                      {subscribedAppList.some(subscribedApp => subscribedApp.nid === detail.nid) ? (

                      <div className="heartIcon !cursor-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0057B8">
                          <path d="M12.62 20.8096C12.28 20.9296 11.72 20.9296 11.38 20.8096C8.48 19.8196 2 15.6896 2 8.68961C2 5.59961 4.49 3.09961 7.56 3.09961C9.38 3.09961 10.99 3.97961 12 5.33961C13.01 3.97961 14.63 3.09961 16.44 3.09961C19.51 3.09961 22 5.59961 22 8.68961C22 15.6896 15.52 19.8196 12.62 20.8096Z" stroke="#0057B8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                      ) : (
                      <div className="heartIcon !cursor-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M12.62 20.8096C12.28 20.9296 11.72 20.9296 11.38 20.8096C8.48 19.8196 2 15.6896 2 8.68961C2 5.59961 4.49 3.09961 7.56 3.09961C9.38 3.09961 10.99 3.97961 12 5.33961C13.01 3.97961 14.63 3.09961 16.44 3.09961C19.51 3.09961 22 5.59961 22 8.68961C22 15.6896 15.52 19.8196 12.62 20.8096Z" stroke="#0057B8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                      )}                           
                    </>
                      : <div className="addText text-primaryText text-base leading-5 sm:text-xl sm:leading-6 font-medium tracking-[-0.05px] flex items-center" onClick={goToRegister}>Register to join the Source</div>}
                  </div>
                </div>
              </div>
              <div className="mt-6">
                <div className="flex items-center gap-4 sm:gap-6 justify-between">
                  <div className="eyeMastersIconHolder shrink-0">
                    <img src={`${MEDIA_ORIGIN}${detail.icon}`} className="w-14 sm:w-[100px]" />
                  </div>
                  <div className="appTitleSection grow">
                    <div className="flex flex-col  gap-[6px] sm:gap-2">
                      <div className="flex justify-between gap-2 flex-wrap">
                        <p className="grow text-[#333] barlowBold text-xl leading-6 sm:text-[32px] sm:leading-10">{detail.title}</p>
                        <div className="actionSection sm:flex gap-6 items-center hidden">
                          <div className="appStatus text-[#333] text-base font-normal leading-5 tracking-[-0.25px] h-[30px] w-[86px]  rounded-[50px] bg-[#E4ECF266] border borer-[#7DA1C4]  items-center justify-center !hidden">Internal</div>
                          {resourceType && resourceType.includes(2) === true && <>
                            <div className="monitor cursor-pointer hidden">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M17.56 17.97H6.44C2.46 17.97 1.25 16.76 1.25 12.78V6.44C1.25 2.46 2.46 1.25 6.44 1.25H17.55C21.53 1.25 22.74 2.46 22.74 6.44V12.77C22.75 16.76 21.54 17.97 17.56 17.97ZM6.44 2.75C3.3 2.75 2.75 3.3 2.75 6.44V12.77C2.75 15.91 3.3 16.46 6.44 16.46H17.55C20.69 16.46 21.24 15.91 21.24 12.77V6.44C21.24 3.3 20.69 2.75 17.55 2.75H6.44Z" fill="#717375" />
                                <path d="M12 22.7497C11.59 22.7497 11.25 22.4097 11.25 21.9997V17.2197C11.25 16.8097 11.59 16.4697 12 16.4697C12.41 16.4697 12.75 16.8097 12.75 17.2197V21.9997C12.75 22.4097 12.41 22.7497 12 22.7497Z" fill="#717375" />
                                <path d="M22 13.75H2C1.59 13.75 1.25 13.41 1.25 13C1.25 12.59 1.59 12.25 2 12.25H22C22.41 12.25 22.75 12.59 22.75 13C22.75 13.41 22.41 13.75 22 13.75Z" fill="#717375" />
                                <path d="M16.5 22.75H7.5C7.09 22.75 6.75 22.41 6.75 22C6.75 21.59 7.09 21.25 7.5 21.25H16.5C16.91 21.25 17.25 21.59 17.25 22C17.25 22.41 16.91 22.75 16.5 22.75Z" fill="#717375" />
                              </svg>
                            </div>
                            {detail.enable_visit === 'True' && <><div class="addText text-primaryText text-base sm:text-xl leading-6 font-medium tracking-[-0.05px] cursor-pointer" onClick={() => handleViewApp(detail.web_app_url)}>Visit</div>
                            <div className="divider w-[1px] h-full bg-[#000] opacity-30"></div></>}
                          </>}
                          <div className="add flex gap-6 cursor-pointer">
                            {currentUser ? <>
                              <div className="addText text-primaryText text-base leading-5 sm:text-xl sm:leading-6 font-medium tracking-[-0.05px] flex items-center" onClick={() => subscribedAppList.some(subscribedApp => subscribedApp.nid === detail.nid) ? handleRemoveAppSubscribe(detail.nid) : handleAppSubscribe(detail.nid, detail.popup_consent)}>{subscribedAppList.some(subscribedApp => subscribedApp.nid === detail.nid) ? 'Remove' : 'Add'}</div>
                              {subscribedAppList.some(subscribedApp => subscribedApp.nid === detail.nid) ? (
                              <div className="heartIcon !cursor-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0057B8">
                                  <path d="M12.62 20.8096C12.28 20.9296 11.72 20.9296 11.38 20.8096C8.48 19.8196 2 15.6896 2 8.68961C2 5.59961 4.49 3.09961 7.56 3.09961C9.38 3.09961 10.99 3.97961 12 5.33961C13.01 3.97961 14.63 3.09961 16.44 3.09961C19.51 3.09961 22 5.59961 22 8.68961C22 15.6896 15.52 19.8196 12.62 20.8096Z" stroke="#0057B8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </div>
                              ) : (
                              <div className="heartIcon !cursor-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M12.62 20.8096C12.28 20.9296 11.72 20.9296 11.38 20.8096C8.48 19.8196 2 15.6896 2 8.68961C2 5.59961 4.49 3.09961 7.56 3.09961C9.38 3.09961 10.99 3.97961 12 5.33961C13.01 3.97961 14.63 3.09961 16.44 3.09961C19.51 3.09961 22 5.59961 22 8.68961C22 15.6896 15.52 19.8196 12.62 20.8096Z" stroke="#0057B8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </div>
                              )}                           
                            </>
                              : <div className="addText text-primaryText text-base sm:text-xl leading-6 font-medium tracking-[-0.05px]" onClick={goToRegister}>Register to join the Source</div>}
                          </div>
                        </div>
                      </div>
                      <div className="divider h-[1px] w-full bg-[#B5CEE1] hidden sm:flex"></div>
                      <p className="text-[#717375] font-normal text-sm leading-5 sm:text-xl sm:leading-[30px]">{detail.summary}</p>
                    </div>
                  </div>
                </div>
                <div className="divider h-[1px] w-full bg-[#B5CEE1] mt-6 block sm:hidden"></div>
                {detail.description && <div className="text-[#333] text-base leading-6 sm:text-xl sm:leading-[30px] font-normal mt-4 max-w-full sm:max-w-[90%] dynamicContent miniScreen" dangerouslySetInnerHTML={{ __html: detail.description }}></div>}
              </div>
            </div>
          </section >
          <section className="section appDetailBanner h-auto sm:h-[600px] bg-[#D9D9D9] border-[2px] border-y-[#8e9398b3]">
            <div className="h-full">
              <div className="px-5 sm:px-5 md:px-5 lg:px-14 py-5 sm:py-5 md:py-5 lg:py-10 h-full overflow-x-hidden">
                <div className="h-full">
                  <div className="flex items-center h-full gap-6 flex-col sm:flex-row">
                    <div className="sliderHolder h-full order-1 sm:order-none">
                      <div className="flex items-center flex-row sm:flex-col h-full gap-5">
                        <div className={`leftArrow rotate-90 sm:rotate-180 cursor-pointer hidden sm:flex ${leftScroll}`} onClick={() => handleNav(5, 400, -10)}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                            <path d="M5.71829 11.4922L13.3591 19.4757C14.2615 20.4185 15.7381 20.4185 16.6404 19.4757L24.2812 11.4922" stroke="#0057B8" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                        <div className="sliderImagesHolder overflow-x-auto grow" ref={cardRef}>
                          <div className="flex items-center gap-4 flex-nowrap *:shrink-0 sm:*:shrink sm:*:flex-grow *:block flex-row sm:flex-col max-w-full *:max-h-auto sm:*:max-h-[90px] *:h-[90px] sm:*:h-[90px] sm:*:max-h-auto *:max-w-[45%] sm:*:max-w-[150px] *:cursor-pointer sm:*:w-[150px] *:object-contain *:bg-[#f5f5f5] *:w-[120px] *:rounded-md">
                            {sliderList && sliderList.map((details, key) =>
                              <Fragment key={key}>
                                {(details.substring(details.lastIndexOf('.') + 1, details.length) === 'png' || details.substring(details.lastIndexOf('.') + 1, details.length) === 'jpg') &&
                                  <img
                                    src={`${MEDIA_ORIGIN}${details.trim()}`}
                                    onClick={() => handleItemSelected(details.trim())}
                                    alt="sliderBanner"
                                  />}
                                {details.substring(details.lastIndexOf('.') + 1, details.length) === 'mp4' &&
                                  <ReactPlayer key={key} className="!h-[90px] !w-[120px] !max-w-[120px] !max-h-[100px] !sm:h-[100px] !sm:max-h-[90px] sm:!max-w-[150px] sm:!w-[150px] bg-[#f5f5f5] rounded-md" url={`${MEDIA_ORIGIN}${details.trim()}`} loop={true} muted onClick={() => handleItemSelected(details.trim())} onContextMenu={e => e.preventDefault()} config={{ file: { attributes: { controlsList: 'nodownload' } } }} />
                                }
                              </Fragment>)}
                          </div>
                        </div>
                        <div className={`rightArrow cursor-pointer -rotate-90 sm:rotate-0 hidden sm:flex ${rightScroll}`} onClick={() => handleNav(5, 400, +10)}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                            <path d="M5.71829 11.4922L13.3591 19.4757C14.2615 20.4185 15.7381 20.4185 16.6404 19.4757L24.2812 11.4922" stroke="#0057B8" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="appBannerImageHolder bg-white sm:bg-transparent h-[240px] sm:h-[492px] rounded-2xl mx-auto">
                      {displaySliderItem && (displaySliderItem.substring(displaySliderItem.lastIndexOf('.') + 1, displaySliderItem.length) === 'png' || displaySliderItem.substring(displaySliderItem.lastIndexOf('.') + 1, displaySliderItem.length) === 'jpg') &&
                        <img
                          src={`${MEDIA_ORIGIN}${displaySliderItem.trim()}`}
                          alt="sliderBanner"
                          className="h-full object-contain rounded-2xl" />}
                      {displaySliderItem && displaySliderItem.substring(displaySliderItem.lastIndexOf('.') + 1, displaySliderItem.length) === 'mp4' &&

                        <ReactPlayer key={key} className="!size-full" url={`${MEDIA_ORIGIN}${displaySliderItem.trim()}`} loop={true} muted playing controls={true} onContextMenu={e => e.preventDefault()} config={{ file: { attributes: { controlsList: 'nodownload' } } }} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="section otherResourcesSection">
            <div className="px-5 sm:px-5 md:px-5 lg:px-14 py-8 lg:py-14">
              {relatedAppList.length > 0 && <div className="otherResources">
                <h4 className="subTitle text-[#000] barlowBold text-lg leading-[22px] sm:text-lg sm:leading-6">Other Resources You Might Like</h4>
                <div className="mt-6">
                  <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-14 gap-y-6 sm:gap-y-12 *:cursor-pointer">
                    {relatedAppList.map((relatedApp, key) => <div className="app" key={key} onClick={() => goToAppDetailPage(relatedApp.slug_url)}>
                      <div className="grid grid-cols-[auto,1fr] gap-4 sm:gap-6 w-full">
                        <div className="appIconHolder w-12 sm:w-[72px]">
                          <img src={`${MEDIA_ORIGIN}${relatedApp.icon}`} className="w-full" alt="course icon" />
                        </div>
                        <div className="appInfo flex flex-col gap-1 sm:gap-2 justify-center">
                          <h6 className="appTitle text-[#333] text-base leading-5 sm:text-lg font-medium sm:leading-6">{relatedApp.title}</h6>
                          <p className="text-[#333] text-xs leading-4 sm:text-base sm:leading-5 font-normal md:max-w-[70%] max-w-full lg:max-w-[80%]">{relatedApp.summary}</p>
                        </div>
                      </div>
                    </div>)}
                  </div>
                </div>
              </div>}
            </div>
          </section>
        </Fragment>
      )}
    </div >
  );
};

export default AppDetailContent;
